import React, { useState, useEffect } from "react";
import api from "../api";
import { useNavigate } from "react-router-dom";

/* ---------------- Razorpay Loader ---------------- */
const loadRazorpay = () =>
  new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });

export default function Subscription() {
  const nav = useNavigate();

  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [billing, setBilling] = useState("monthly");
  const [loading, setLoading] = useState(false);

  /* -------- LOAD CLASSES -------- */
  useEffect(() => {
    api.get("/student/classes").then((res) => setClasses(res.data || []));
  }, []);

  /* -------- LOAD SUBJECTS -------- */
  useEffect(() => {
    if (!selectedClass) {
      setSubjects([]);
      setSelectedSubjects([]);
      return;
    }

    api
      .get(`/student/subjects?class_id=${selectedClass}`)
      .then((res) => setSubjects(res.data || []));
  }, [selectedClass]);

  /* -------- SUBJECT SELECT -------- */
  const toggleSubject = (id) => {
    const sid = Number(id);

    setSelectedSubjects((prev) =>
      prev.includes(sid)
        ? prev.filter((x) => x !== sid)
        : [...prev, sid]
    );
  };

  /* -------- PRICE CALCULATION -------- */

  const total = selectedSubjects.length;
  const free = Math.floor(total / 5);
  const payable = total - free;

  const unit = billing === "monthly" ? 10 : 100;
  const amount = payable * unit;

  /* -------- CREATE ORDER -------- */

  const createOrder = async () => {
    if (amount <= 0) return alert("Please select subjects");

    setLoading(true);

    try {
      const loaded = await loadRazorpay();
      if (!loaded) throw new Error("Razorpay failed");

      const res = await api.post("/payment/create-order", {
        subject_ids: selectedSubjects,
        billing_type: billing,
      });

      const { order_id, amount: paise, razorpay_key } = res.data;

      new window.Razorpay({
        key: razorpay_key,
        amount: paise,
        currency: "INR",
        name: "EduAt10",
        description: "EduAt10 Subscription",
        order_id,

        handler: async (response) => {
          await api.post("/subscription/verify", response);

          alert("✅ Subscription Activated");

          nav("/user/dashboard");
        },
      }).open();
    } catch {
      alert("Payment failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={page}>
      <div style={overlay}>
        <div style={card}>
          <img src="/logo.png" alt="EduAt10" style={logo} />

          <h2>🎟️ Buy Subscription</h2>
          <p>Eduat10 में पढ़ाई की शुरुआत ₹10 प्रति विषय प्रति माह और ₹100 प्रति विषय प्रति वर्ष से होती है। 5 विषय चुनने पर 1 विषय बिल्कुल FREE मिलता है। "Eduat10 offers affordable learning starting from INR 10 per subject monthly and INR 100 yearly. Select 5 subjects and get 1 subject FREE."</p>

          {/* CLASS SELECT */}

          <select
            value={selectedClass}
            onChange={(e) => setSelectedClass(e.target.value)}
            style={input}
          >
            <option value="">Select Class</option>

            {classes.map((c) => (
              <option key={c.id} value={c.id}>
                {c.name}
              </option>
            ))}
          </select>

          {/* SUBJECTS */}

          {subjects.length > 0 && (
            <div style={{ marginTop: 10 }}>
              <h4>Select Subjects</h4>

              {subjects.map((s) => (
                <label key={s.id} style={checkbox}>
                  <input
                    type="checkbox"
                    checked={selectedSubjects.includes(Number(s.id))}
                    onChange={() => toggleSubject(s.id)}
                  />
                  {s.name}
                </label>
              ))}
            </div>
          )}

          {/* BILLING */}

          {selectedSubjects.length > 0 && (
            <>
              <h4 style={{ marginTop: 20 }}>Billing</h4>

              <label style={checkbox}>
                <input
                  type="radio"
                  checked={billing === "monthly"}
                  onChange={() => setBilling("monthly")}
                />
                Monthly ₹10 / subject
              </label>

              <label style={checkbox}>
                <input
                  type="radio"
                  checked={billing === "yearly"}
                  onChange={() => setBilling("yearly")}
                />
                Yearly ₹100 / subject
              </label>

              {/* PRICE SUMMARY */}

              <div style={summary}>
                <p>Total Subjects: {total}</p>
                <p>Free Subjects: {free}</p>
                <p>Payable Subjects: {payable}</p>

                <h3>Amount: ₹{amount}</h3>
              </div>

              {/* PAY BUTTON */}

              <button
                disabled={loading}
                onClick={createOrder}
                style={btn}
              >
                {loading ? "Processing..." : `Pay ₹${amount}`}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

/* ---------------- STYLES ---------------- */

const page = {
  minHeight: "100vh",
  backgroundImage: "url('/eduat10-bg.png')",
  backgroundSize: "cover",
};

const overlay = {
  minHeight: "100vh",
  background: "rgba(0,0,0,0.3)",
  padding: 20,
};

const card = {
  maxWidth: 700,
  margin: "auto",
  background: "#fff",
  padding: 30,
  borderRadius: 16,
};

const logo = {
  width: 120,
  marginBottom: 10,
};

const input = {
  width: "100%",
  padding: 10,
  marginBottom: 10,
};

const checkbox = {
  display: "block",
  marginBottom: 6,
};

const summary = {
  marginTop: 16,
  padding: 12,
  background: "#f1f5f9",
  borderRadius: 8,
};

const btn = {
  marginTop: 20,
  padding: 12,
  background: "#2563eb",
  color: "#fff",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
};
